module.exports = __webpack_public_path__ + "img/add_cart.0c8a20a8.svg";